import { Dialog as BaseDialog } from '@base-ui/react/dialog';
import type { CSSObject, Theme } from '@emotion/react';
import styled from '@emotion/styled';

import { focusRing, hoverable } from '../../interaction-states';
import { spacing } from '../../spacing';

export const StyledBackdrop = styled(BaseDialog.Backdrop)(({ theme }) => ({
  position: 'fixed',
  minHeight: '100dvh',
  inset: 0,
  backgroundColor: theme.colors.black[100],
  opacity: 0.8,
  transition: 'opacity 150ms cubic-bezier(0.45, 1.005, 0, 1.005)',
  touchAction: 'none',

  '&[data-starting-style], &[data-ending-style]': {
    opacity: 0,
  },
}));

export const StyledPopup = styled(BaseDialog.Popup)({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  gap: spacing[12],
  width: 'max-content',
  maxWidth: 'min(1200px, 92vw)',
  maxHeight: '92dvh',
  outline: 'none',
  transition: 'all 150ms',

  '&[data-starting-style], &[data-ending-style]': {
    opacity: 0,
    transform: 'translate(-50%, -50%) scale(0.95)',
  },
});

export const HeaderBar = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: spacing[12],
  minWidth: 0,

  '& > h2': {
    flex: 1,
    minWidth: 0,
  },
});

export const Actions = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: spacing[8],
  flexShrink: 0,
});

const controlBase = (theme: Theme): CSSObject => ({
  ...hoverable(theme),
  ...focusRing(theme),
  boxSizing: 'border-box',
  padding: spacing[4],
  background: 'none',
  border: 'none',
  borderRadius: theme.radius[4],
  cursor: 'pointer',
  color: theme.colors.text.primary,
  flexShrink: 0,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 28,
  height: 28,

  svg: {
    width: '100%',
    height: '100%',
  },
});

export const ControlButton = styled('button')(({ theme }) => controlBase(theme));

export const ControlLink = styled('a')(({ theme }) => controlBase(theme));

export const FullImage = styled('img')(({ theme }) => ({
  display: 'block',
  maxWidth: '100%',
  maxHeight: 'calc(92dvh - 64px)',
  objectFit: 'contain',
  borderRadius: theme.radius[8],
}));
